import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=3044575e&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=3044575e&prod&scoped=true&lang=scss"
import style1 from "./personalCenter.vue?vue&type=style&index=1&id=3044575e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3044575e",
  null
  
)

export default component.exports